import { useTranslation } from "react-i18next";
import { SalesReturn } from "types/SalesReturn";
import DataTable from "components/datatable/Datatable";

type Props = {
  salesReturns: SalesReturn[];
};

const SalesReturns = ({ salesReturns }: Props) => {
  const { t } = useTranslation();

  return (
    <DataTable
      collection={salesReturns}
      columns={[
        { key: "#" },
        { key: "number", name: t("number") },
        { key: "date", type: "date", name: t("date") },
        { key: "customerName", name: t("customer") },
        { key: "_amountWithVat", type: "currency", name: t("totalWithVat") },
        { key: "_amount", type: "currency", name: t("totalWithoutVat") },
        { key: "_debt", type: "currency", name: t("debt") },
        { key: "paymentDueDate", type: "date", name: t("payment_due_date") },
      ]}
    />
  );
};

export default SalesReturns;
